import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from "react-redux";
import React, {Component} from "react";
import dot from "dot-object";
import {formatValues} from "./FormatValues";

class FormatMessage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (this.props.children != undefined ? <FormattedMessage id={this.props.id} values={formatValues}>
                {this.props.children}
            </FormattedMessage> :
            <FormattedMessage id={this.props.id}
                              values={formatValues}>
                {(message) => message.length > 1 ? message : this.formatMsg(message.toString())}
            </FormattedMessage>)
    }

    formatMsg(message) {
        let msg = message.match(/\${([^}]+)\}/g)
        if (msg != undefined && msg != null) {
            msg.forEach(v => {
                if (v.includes("${keyvar:")) {
                    let msgData = v.replace("${keyvar:", "").replace("}", "")
                    let data = dot.pick(msgData, this.props.applicationData)
                    let fallbackMsg = this.props.intl.messages[data]
                    if (fallbackMsg != undefined && fallbackMsg != null) {
                        message = message.replace(v, fallbackMsg)
                    } else {
                        message = message.replace(v, data)
                    }
                }
            })
        }
        return message
    }
}

const mapStateToProps = state => {
    return {
        applicationData: state.application.applicationData
    }
}

export default connect(mapStateToProps)(injectIntl(FormatMessage))
